// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__rNbzM","text":"styles_text___6tGZ"};